import { ReactNode } from 'react';
import { ChLink } from '../ch-link';

export function TextWithLinks({ text }: { text: string | ReactNode }) {
    if (typeof text !== 'string') return;
    const parts = text.split(/(https?:\/\/[^\s]+)/);
    return (
        <>
            {parts.map((part, index) => {
                if (part.match(/https?:\/\/[^\s]/)) {
                    return (
                        <ChLink
                            key={index}
                            href={part}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {part}
                        </ChLink>
                    );
                }
                return part;
            })}
        </>
    );
}
